var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container process-details" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _c("div", { staticClass: "content page-title" }, [
        _c("h2", [_vm._v(_vm._s(_vm.pageTitle))]),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          [
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "审批流名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: {
                        maxlength: "20",
                        "show-word-limit": "",
                        placeholder: "请输入内容",
                        size: "small",
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.form,
                            "name",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "指定功能", prop: "funcCodes" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择指定功能",
                          size: "small",
                          multiple: "",
                        },
                        model: {
                          value: _vm.form.funcCodes,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "funcCodes", $$v)
                          },
                          expression: "form.funcCodes",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.process_func,
                        function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "适用部门", prop: "orgCodeItem" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.orgCodeList,
                        props: {
                          label: "orgName",
                          value: "orgCode",
                          multiple: true,
                          checkStrictly: true,
                        },
                        "collapse-tags": "",
                        clearable: "",
                        size: "small",
                        placeholder: "请选择适用部门",
                      },
                      on: { change: _vm.handleChange },
                      model: {
                        value: _vm.form.orgCodeItem,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "orgCodeItem", $$v)
                        },
                        expression: "form.orgCodeItem",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "审批流设置" } },
                  [
                    _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading",
                          },
                        ],
                        attrs: {
                          border: "",
                          data: _vm.form.steps,
                          "span-method": _vm.objectSpanMethod,
                          "header-cell-style": _vm.headerStyle,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "sequence",
                            align: "center",
                            label: "审核步骤",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "节点标题", prop: "title" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("el-input", {
                                    attrs: {
                                      maxlength: "8",
                                      "show-word-limit": "",
                                      size: "small",
                                      placeholder: "请输入内容",
                                    },
                                    model: {
                                      value: props.row.title,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          props.row,
                                          "title",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "props.row.title",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "公司部门",
                            prop: "orgCode",
                            width: "250",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("el-cascader", {
                                    attrs: {
                                      "show-all-levels": false,
                                      options: _vm.orgCodeList,
                                      props: {
                                        label: "orgName",
                                        value: "orgCode",
                                        children: "children",
                                        checkStrictly: true,
                                      },
                                      size: "small",
                                      placeholder: "请选择适用部门",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.onChangeOrgCodes(
                                          props.row,
                                          props.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: props.row.orgCode,
                                      callback: function ($$v) {
                                        _vm.$set(props.row, "orgCode", $$v)
                                      },
                                      expression: "props.row.orgCode",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "角色", prop: "roleId" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择角色",
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onChangeRoleId(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: props.row.roleId,
                                        callback: function ($$v) {
                                          _vm.$set(props.row, "roleId", $$v)
                                        },
                                        expression: "props.row.roleId",
                                      },
                                    },
                                    _vm._l(
                                      props.row.roleIdArr,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "职员", prop: "userId" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请选择职员",
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.onChangeUserId(
                                            props.row,
                                            props.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: props.row.userId,
                                        callback: function ($$v) {
                                          _vm.$set(props.row, "userId", $$v)
                                        },
                                        expression: "props.row.userId",
                                      },
                                    },
                                    _vm._l(
                                      props.row.userIdArr,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: item.name,
                                            value: item.id,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "是否必审",
                            prop: "mustFlag",
                            width: "120",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("el-switch", {
                                    attrs: {
                                      "active-value": 1,
                                      "inactive-value": 0,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.tableMustFlag(
                                          props.row,
                                          props.$index
                                        )
                                      },
                                    },
                                    model: {
                                      value: props.row.mustFlag,
                                      callback: function ($$v) {
                                        _vm.$set(props.row, "mustFlag", $$v)
                                      },
                                      expression: "props.row.mustFlag",
                                    },
                                  }),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addParallel(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("添加并行")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.upMove(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("上移")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.upDown(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("下移")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", width: "120" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: { type: "danger" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.rowDelete(
                                            scope.$index,
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "add-property" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: { click: _vm.addProperty },
                          },
                          [_vm._v("继续添加步骤")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "备注信息", prop: "remarks" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "请输入备注信息",
                        maxlength: "20",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.form.remarks,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "remarks", $$v)
                        },
                        expression: "form.remarks",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否启用" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "status", $$v)
                          },
                          expression: "form.status",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.enable_status,
                        function (item, index) {
                          return _c(
                            "el-radio",
                            { key: index, attrs: { label: item.dictId } },
                            [_vm._v(_vm._s(item.dictName))]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否必审" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.form.mustFlag,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "mustFlag", $$v)
                          },
                          expression: "form.mustFlag",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("必审"),
                        ]),
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("非必审"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "submit-but",
                attrs: { type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.verificationForm("form")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.submitText))]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }